import { planTypes } from '@/common/constants';
import { getPlanLogo } from '@/common/plan-logo-map';
import { enableCAICPlanRebranding } from './utils.js';

export default {
  key: planTypes[planTypes.ZOOM_CUSTOM_AI_COMPANION],
  data() {
    return {
      logo: getPlanLogo(planTypes.ZOOM_CUSTOM_AI_COMPANION),
      title: enableCAICPlanRebranding
        ? this.$t('billing.zoom_custom_ai_companion.rebranding_title')
        : this.$t('billing.zoom_custom_ai_companion.title'),
      planType: planTypes.ZOOM_CUSTOM_AI_COMPANION,
      description: this.$t('billing.zoom_custom_ai_companion.desc'),
    };
  },
};
